import { DialogComponent } from '@theme/dialog';
import { initProductPurchaseSidebar } from '@theme/product-purchase-sidebar';

class ProductPreviewDialog extends DialogComponent {}

if (!customElements.get('product-preview-dialog')) {
  customElements.define('product-preview-dialog', ProductPreviewDialog);
}

class ProductPreviewController {
  /** @type {Map<string, Element>} */
  #cache = new Map();

  /** @type {AbortController | null} */
  #abortController = null;

  constructor() {
    document.addEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = async (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-product-preview]') : null;
    if (!trigger || !(trigger instanceof HTMLAnchorElement) || !trigger.href) return;

    event.preventDefault();
    event.stopPropagation();

    await this.open(trigger.href);
  };

  /**
   * @param {string} productUrl
   */
  async open(productUrl) {
    const dialogComponent = document.getElementById('product-preview-dialog');
    const modalContent = document.getElementById('product-preview-modal-content');

    if (!(dialogComponent instanceof ProductPreviewDialog) || !modalContent) return;

    this.#setLoading(modalContent);
    dialogComponent.showDialog();

    try {
      const grid = await this.#loadProductGrid(productUrl);
      if (!grid) {
        window.location.href = productUrl;
        dialogComponent.closeDialog();
        return;
      }

      modalContent.innerHTML = '';
      modalContent.appendChild(grid);
      initProductPurchaseSidebar(modalContent);
    } catch {
      window.location.href = productUrl;
      dialogComponent.closeDialog();
    }
  }

  /**
   * @param {HTMLElement} modalContent
   */
  #setLoading(modalContent) {
    modalContent.innerHTML = '<p class="product-preview-modal__loading">Loading…</p>';
  }

  /**
   * @param {string} productUrl
   * @returns {Promise<Element | null>}
   */
  async #loadProductGrid(productUrl) {
    const cached = this.#cache.get(productUrl);
    if (cached) {
      return /** @type {Element} */ (cached.cloneNode(true));
    }

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const response = await fetch(productUrl, { signal: this.#abortController.signal });
    if (!response.ok) throw new Error(`Failed to fetch product page: ${response.status}`);

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const grid = html.querySelector('[data-product-grid-content].product-information__grid--aliexpress');

    if (!grid) return null;

    const clone = /** @type {Element} */ (grid.cloneNode(true));
    this.#cache.set(productUrl, /** @type {Element} */ (grid.cloneNode(true)));
    return clone;
  }
}

new ProductPreviewController();
